interface SectionDividerProps {
  variant?: 'gradient' | 'dots' | 'wave';
  className?: string;
}

export function SectionDivider({ variant = 'gradient', className = '' }: SectionDividerProps) {
  if (variant === 'gradient') {
    return (
      <div className={`my-16 md:my-20 ${className}`}>
        <div className="h-px bg-slate-700/50" />
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className={`flex justify-center gap-3 my-16 md:my-20 ${className}`}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full ${i === 1 ? 'bg-indigo-500/50' : 'bg-indigo-500/30'}`}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={`my-16 md:my-20 overflow-hidden ${className}`}>
      <svg viewBox="0 0 1200 20" className="w-full h-5 fill-indigo-500/10">
        <path d="M0,10 Q300,0 600,10 T1200,10 V20 H0 Z" />
      </svg>
    </div>
  );
}
